var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.59961C16 4.93087 15.7316 5.20001 15.4004 5.2002C15.069 5.2002 14.7998 4.93098 14.7998 4.59961V2.20215L8.81836 6.70801L5.71582 4.24316L0.9375 7.49609C0.663575 7.68231 0.289895 7.61078 0.103516 7.33691C-0.0824584 7.06303 -0.0110425 6.69023 0.262695 6.50391L5.77051 2.75488L6.11523 3.03027L8.83789 5.19141L14.1367 1.2002H11.7998C11.4685 1.20006 11.2002 0.9309 11.2002 0.599609C11.2004 0.268499 11.4687 0.000130694 11.7998 0H16V4.59961Z",
    fill: "#62C054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/ArrowGreen.d039832572527d2505d807a4c670a12f.svg";
export { ForwardRef as ReactComponent };